<template>
	<div class="results-bar">
		<div
			v-for="(category, key) in renamedScores"
			:key="key"
			class="results-bar__progress"
		>
			<div class="results-bar__top">
				<div class="results-bar__name">{{ key }}</div>
				<div class="results-bar__percentage">
					{{ Math.round(category * 100) }}%
				</div>
			</div>
			<div class="results-bar__bar">
				<div
					:style="{
						width: category * 100 + '%',
						background: barColor(category)
					}"
					class="results-bar__bar-inner"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import survey from "@/survey";
import i18n from "@/plugins/i18n";

export default {
	props: {
		scores: {
			type: Object,
			required: true
		},
	},
	computed: {
		locale() {
			return i18n.locale;
		},
		renamedScores() {
			const obj = {};
			Object.entries(this.scores).forEach(([id, value]) => {
				obj[survey.getCategoryById(id).name[this.locale]] = value;
			});
			return obj;
		}
	},
	methods: {
		barColor(value) {
			return value < 0.75 ? "#e41f18" : "#a5c100";
		}
	},
};
</script>

<style>
.results-bar {
	position: relative;
	margin-bottom: 30px;
}
.results-bar__progress {
	display: flex;
	align-items: stretch;
	justify-content: center;
	flex-direction: column;
	position: relative;
}
.results-bar__bar {
	height: 10px;
	background-color: #f3f3f3;
}
.results-bar__bar-inner {
	height: 100%;
}
.results-bar__top {
	display: flex;
	justify-content: space-between;
	padding-bottom: 10px;
	position: relative;
}
.results-bar__name {
	font-family: Verdana;
	font-size: 15px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: normal;
	color: #1d1d1d;
}
.results-bar__percentage {
	font-family: Verdana;
	font-size: 12px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: normal;
	text-align: right;
	color: #1d1d1d;
}
.results-bar__line {
	position: absolute;
	left: 75%;
	border: dashed 1px #d0d0d0;
	top: 0;
	bottom: 0;
	transform: translateX(-50%);
}
.results-bar__line-text {
	position: absolute;
	left: 75%;
	transform: translateX(-50%);
	bottom: calc(100% + 5px);
	font-family: TheSansOsF;
	font-size: 14px;
	font-weight: normal;
	font-style: italic;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: normal;
	text-align: center;
	color: #696868;
}
</style>
